import React from 'react';
import TextyAnim from 'rc-texty';

const CustomAnimation = ({ text }) => {
  return <TextyAnim type="alpha">{text}</TextyAnim>;
};

export default CustomAnimation;
